import { AUTH_USER } from '../constants/localStorage';
import { LANGUAGES_LIST, DEFAULT_LANGUAGE } from '../constants/languages';

export const setUser = (authUser) => {
  localStorage.setItem(AUTH_USER, JSON.stringify(authUser));
};

export const getUser = () => {
  const authUserStorage = localStorage.getItem(AUTH_USER);
  return authUserStorage ? JSON.parse(authUserStorage) : null;
};

export const removeUser = () => {
  localStorage.removeItem(AUTH_USER);
};

export const getLanguage = () => {
  const user = getUser();
  return user && user.language && LANGUAGES_LIST.includes(user.language) ? user.language : DEFAULT_LANGUAGE;
};

export const getDarkMode = () => {
  const user = getUser();
  return !!(user && user.isDarkMode);
};
